export const MARKETING_HUB_NOTIFICATION_ACTION = 'pro-notification-marketing-hub-clicked';
